export default __webpack_public_path__ + "search-examples-uitextfield-search-960-06c137c814237b1b7b0151ec9240bd36.png";